// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function loadAllReactions() {
    const url = '/v5/messaging/reactions';
    return await authenticatedFetch(url);
}



// WEBPACK FOOTER //
// ./src/v5/messaging/api/loadAllReactions.js